import { ExtensionComponentProps } from 'piral-core'
import * as React from 'react'
import { useTheme } from '../theming';

export default function SettingsAccessibility(props: ExtensionComponentProps<any>) {
    const [theme, setTheme] = useTheme()

    let colorSelector = React.createRef<HTMLElement>();
    let scaleSelector = React.createRef<HTMLElement>();

    React.useEffect(() => {
        if (!colorSelector.current) return;
        if (!theme) return;
        let handler = (e) => {
            let isAuto = e.target.selected[0] == 'auto';
            setTheme({ color: isAuto ? null : e.target.selected[0], followSystem: isAuto })
        }
        colorSelector.current?.addEventListener('change', handler)
        colorSelector.current.selected = theme.followSystem == true ? 'auto' : theme.color;
        return () => {
            colorSelector.current?.removeEventListener('change', handler);
        }
    }, [colorSelector, theme])

    React.useEffect(() => {
        if (!scaleSelector.current) return;
        if (!theme) return;
        let handler = e => {
            setTheme({ scale: e.target.selected[0] })
        }
        scaleSelector.current?.addEventListener('change', handler)
        scaleSelector.current.selected = theme.scale ?? 'medium';
        return () => {
            scaleSelector.current?.removeEventListener('change', handler);
        }
    }, [scaleSelector, theme])

    return (
        <p>
            <sp-table no-hover>
                <sp-table-body>
                    <sp-table-row>
                        <sp-table-cell>
                            Scale
                            <sp-help-text>Controls the dimensions of the controls and text on the screen</sp-help-text>
                        </sp-table-cell>
                        <sp-table-cell></sp-table-cell>
                        <sp-table-cell>
                            <sp-action-group compact selects='single' ref={scaleSelector}>
                                <sp-action-button value='medium'>
                                    Medium
                                </sp-action-button>
                                <sp-action-button value='large'>
                                    Large
                                </sp-action-button>
                            </sp-action-group>
                        </sp-table-cell>
                    </sp-table-row>
                    <sp-table-row>
                        <sp-table-cell>
                            Mode
                            <sp-help-text>Change the warmth of the colours used</sp-help-text>
                        </sp-table-cell>
                        <sp-table-cell></sp-table-cell>
                        <sp-table-cell><sp-action-group compact selects='single' ref={colorSelector}>
                            <sp-action-button value='auto'>
                                Auto
                            </sp-action-button>
                            <sp-action-button value='light'>
                                Light
                            </sp-action-button>
                            <sp-action-button value='dark'>
                                Dark
                            </sp-action-button>
                        </sp-action-group></sp-table-cell>
                    </sp-table-row>
                </sp-table-body>
            </sp-table>
        </p>
    )
}
